document.addEventListener('DOMContentLoaded', () => {
  console.log('✅ USWE v2 image swatch script loaded');

  // --- Get product data ---
  const productJsonEl = document.querySelector('#ProductJson');
  if (!productJsonEl) {
    console.warn('⚠️ Product JSON not found');
    return;
  }

  const productData = JSON.parse(productJsonEl.textContent);
  console.log('🧩 productData loaded', productData);

  // --- Detect main variant option ("Color" or fallback) ---
  let mainOptionName = 'Color';
  let optionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color');
  let optionInputsSelector = `input[name^="options[${mainOptionName}]"]`;
  let optionInputs = document.querySelectorAll(optionInputsSelector);

  const fallbackOptions = ['opening', 'closure', 'harness'];
  if (optionInputs.length <= 1 || optionIndex === -1) {
    for (const alt of fallbackOptions) {
      const idx = productData.options.findIndex(opt => opt.toLowerCase() === alt);
      if (idx !== -1) {
        mainOptionName = alt.charAt(0).toUpperCase() + alt.slice(1);
        optionIndex = idx;
        optionInputsSelector = `input[name^="options[${mainOptionName}]"]`;
        optionInputs = document.querySelectorAll(optionInputsSelector);
        break;
      }
    }

    if (optionIndex === -1) {
      document.querySelectorAll('.product__slide, .product__thumb').forEach(el => (el.style.display = ''));
      return;
    }
  }

  // --- Build image mapping ---
  const optionImageRanges = {};
  productData.variants.forEach(variant => {
    if (variant.featured_media) {
      const value = variant[`option${optionIndex + 1}`];
      optionImageRanges[value] = variant.featured_media.position;
    }
  });

  const sortedValues = Object.keys(optionImageRanges).sort(
    (a, b) => optionImageRanges[a] - optionImageRanges[b]
  );

  const optionImageGroups = {};
  sortedValues.forEach((value, i) => {
    const start = optionImageRanges[value];
    const end = i < sortedValues.length - 1
        ? optionImageRanges[sortedValues[i + 1]] - 1
        : productData.media.length;
    optionImageGroups[value] = { start, end };
  });

  // --- Update gallery ---
  function updateImages(selectedValue) {
    const group = optionImageGroups[selectedValue];
    if (!group) return;

    const slides = document.querySelectorAll('.product__slide');
    const thumbs = document.querySelectorAll('.product__thumb');

    slides.forEach((el, index) => {
      const pos = index + 1;
      el.style.display = pos >= group.start && pos <= group.end ? '' : 'none';
    });

    thumbs.forEach((el, index) => {
      const pos = index + 1;
      el.style.display = pos >= group.start && pos <= group.end ? '' : 'none';
    });
  }

  // --- Auto-select initial variant (with Scroll Protection) ---
  function selectInitialVariant() {
    // Capture current scroll position (likely 0,0 on load)
    const savedX = window.scrollX;
    const savedY = window.scrollY;

    const checked = document.querySelector('input[data-single-option-selector]:checked');
    let initialValue = null;

    if (checked) {
      initialValue = checked.value.trim();
    } else {
      const firstAvail = productData.variants.find(v => v.available) || productData.variants[0];
      if (firstAvail) {
        initialValue = firstAvail[`option${optionIndex + 1}`];
      }
    }

    if (!initialValue) return false;

    // Find the input to match
    const inputs = [...document.querySelectorAll('input[data-single-option-selector]')];
    const match = inputs.find(el => el.value.trim().toLowerCase() === initialValue.toLowerCase());

    if (match) {
      // 1. Manually sync our image hiding first
      updateImages(initialValue);

      // 2. Update the input state
      match.checked = true;

      // 3. Dispatch change to let theme update price/info
      // This is what usually causes the jump in Broadcast
      match.dispatchEvent(new Event('change', { bubbles: true }));

      // 4. Update Swatch UI
      const activeSwatch = [...document.querySelectorAll('.uswe-color-swatch')]
        .find(el => el.dataset.value.trim().toLowerCase() === initialValue.toLowerCase());
      if (activeSwatch) {
        document.querySelectorAll('.uswe-color-swatch.active').forEach(el => el.classList.remove('active'));
        activeSwatch.classList.add('active');
      }

      // 5. THE FIX: Force scroll back to original position after the theme's script runs
      requestAnimationFrame(() => {
        window.scrollTo(savedX, savedY);
      });

      return true;
    }
    return false;
  }

  // --- Swatch Click Logic ---
  document.querySelectorAll('.uswe-color-swatch').forEach(swatch => {
    swatch.addEventListener('click', e => {
      e.preventDefault();
      const value = swatch.dataset.value;
      const inputs = Array.from(document.querySelectorAll('input[data-single-option-selector]'));
      const match = inputs.find(el => el.value.toLowerCase() === value.trim().toLowerCase());

      if (match) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }

      document.querySelectorAll('.uswe-color-swatch.active').forEach(el => el.classList.remove('active'));
      swatch.classList.add('active');
      updateImages(value);
    });
  });

  // --- Native change listeners ---
  optionInputs.forEach(input => {
    input.addEventListener('change', () => updateImages(input.value));
  });

  // --- Run Initialization ---
  const productComponent = document.querySelector('product-component');
  if (productComponent) {
    const observer = new MutationObserver(() => {
      const slides = document.querySelectorAll('.product__slide');
      if (slides.length) {
        if (selectInitialVariant()) observer.disconnect();
      }
    });
    observer.observe(productComponent, { childList: true, subtree: true });
  } else {
    // Fallback if component doesn't exist
    if (!selectInitialVariant()) {
      const observer = new MutationObserver(() => {
        if (selectInitialVariant()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
});